import React from "react";
import {
  ActionIcon,
  Text,
  Flex,
  UnstyledButton,
  ThemeIcon,
} from "@mantine/core";
import { IconLogout } from "@tabler/icons-react";
import axios from "axios";
import useAppStore from "@duck/app-store";

const LogoutButton = ({ text }) => {
  const isAdmin = useAppStore((state) => state.admin) ? true : false;

  function onClick() {
    axios
      .post(`/logout/`)
      .then(() => (window.location = isAdmin ? `/admin` : "/user"))
      .catch((err) => (window.location = isAdmin ? `/admin` : "/user"));
  }

  if (text) {
    return (
      <UnstyledButton onClick={onClick}>
        <Flex>
          <ThemeIcon mr="sm" variant="subtle" color="gray">
            <IconLogout size={18} />
          </ThemeIcon>
          <Text>Logout</Text>
        </Flex>
      </UnstyledButton>
    );
  }

  return (
    <ActionIcon variant="subtle" title="Logout" onClick={onClick}>
      <IconLogout size={14} />
    </ActionIcon>
  );
};

export default LogoutButton;
